import { Icon, IconProps } from "../Icon";

const CheckmarkOutline = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 12.287 28.525 8.72601 25.8995 6.1005C23.274 3.475 19.713 2 16 2ZM14 21.5L9 16.54L10.59 14.97L14 18.35L21.41 11L23 12.58L14 21.5ZM4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16Z"
      fill="currentColor"
    />
  </Icon>
);

export default CheckmarkOutline;
